import axios from 'axios';

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
    timeout: 15000,
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

API.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(err);
    }
);

// ─── Auth ─────────────────────────────────────────────────────────────────────
export const apiLogin = (d) => API.post('/auth/login', d);
export const apiGetMe = () => API.get('/auth/me');
export const apiRegister = (d) => API.post('/auth/register', d);
export const apiChangePassword = (d) => API.put('/auth/password', d);

// ─── Dashboard ────────────────────────────────────────────────────────────────
export const apiGetDashboard = () => API.get('/dashboard');

// ─── Leads ────────────────────────────────────────────────────────────────────
export const apiGetLeads = (p) => API.get('/leads', { params: p });
export const apiGetLead = (id) => API.get(`/leads/${id}`);
export const apiCreateLead = (d) => API.post('/leads', d);
export const apiUpdateLead = (id, d) => API.put(`/leads/${id}`, d);
export const apiDeleteLead = (id) => API.delete(`/leads/${id}`);

// ─── Follow-ups ───────────────────────────────────────────────────────────────
export const apiCreateFollowup = (d) => API.post('/followups', d);
export const apiTodayFollowups = () => API.get('/followups/today');
export const apiLeadFollowups = (id) => API.get(`/leads/${id}/followups`);
export const apiUpdateFollowup = (id, d) => API.put(`/followups/${id}`, d);
export const apiDeleteFollowup = (id) => API.delete(`/followups/${id}`);

// ─── Users ────────────────────────────────────────────────────────────────────
export const apiGetUsers = () => API.get('/users');
export const apiGetCounselors = () => API.get('/users/counselors');
export const apiToggleUser = (id) => API.put(`/users/${id}/toggle`);
export const apiDeleteUser = (id) => API.delete(`/users/${id}`);

// ─── Import / Export ──────────────────────────────────────────────────────────
export const apiImportCSV = (formData) =>
    API.post('/import/csv', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
// Note: export returns XLSX format
export const apiExportLeads = () =>
    API.get('/import/export', { responseType: 'blob' });

// ─── Fees ─────────────────────────────────────────────────────────────────────
export const apiGetAllFees      = ()       => API.get('/fees');
export const apiGetFeeSummary   = ()       => API.get('/fees/summary');
export const apiGetFeeByLead    = (leadId) => API.get(`/fees/lead/${leadId}`);
export const apiGetFeeById      = (id)     => API.get(`/fees/${id}`);
export const apiCreateFee       = (d)      => API.post('/fees', d);
export const apiUpdateFee       = (id, d)  => API.put(`/fees/${id}`, d);
export const apiDeleteFee       = (id)     => API.delete(`/fees/${id}`);
export const apiRecordPayment   = (id, d)  => API.post(`/fees/${id}/payments`, d);

export default API;

